export const EMAIL = `latelierargentique@gmail.com`;
export const PHONE_NUMBER = '+33228294405';

// Types
export const LINK = 'link';
export const SUBMENU_OPENER = 'submenu_opener';
export const ENTETE = 'entete';
export const TITLE = 'title';
export const PARAGRAPH = 'paragraph';
export const BIG_SQUARE_BUTTON = 'big_square_button';
export const ARTICLE = 'article';
export const LEGEND = 'legend';
export const FORM = 'form';
export const INPUT_TEXT = 'input_text';
export const INPUT_MAIL = 'input_mail';
export const INPUT_TEL = 'input_tel';
export const INPUT_SUBMIT = 'input_submit';
export const TEXTAREA = 'textarea';
export const LABEL = 'label';
export const FIELDSET = 'fieldset';
export const OPTIONS_INPUT = 'input_radio';
export const IFRAME = 'iframe';
export const PAGE_TITLE = 'page_title';
export const KEYWORDS = 'keywords';
export const DESCRIPTION = 'description';
export const TARIFS = 'tarifs';
export const COLUMN = 'column';
export const SLIDER = 'slider';
export const FILE_UPLOADER = 'file_uploader';
export const FILES_MANAGER = 'files_manager';
export const LIST = 'list';
export const CHEKBOX = 'checkbox';
export const DIALOG = 'dialog';
export const WARNING = 'warning';

// Links
export const URL_HOME = '/';
export const URL_EQUIPE = '/equipe';
export const URL_CONTACT = '/contact';
export const URL_DEVELOPPEMENT = '/developpement';
export const URL_TIRAGE = '/tirage';
export const URL_ACTUALITES = '/actualites';
export const URL_WORKSHOPS = '/workshops';
export const URL_RESULTATS = '/resultats';
export const LINK_MARATHON02 = '/marathon_02';
export const URL_PRODUITS = '/produits';
export const URL_TARIFS = '/tarifs';
export const URL_TARIFSDEV = '/tarifsdev';
export const URL_TARIFSNUM = '/tarifsnum';
export const URL_TARIFSTIRAGE = '/tarifstirage';
export const URL_TARIFSPF = '/tarifsplanfilm';
export const URL_MENTIONS_LEGALES = '/mentions-legales';
export const URL_CGV = '/cgv';
export const URL_CORRESPONDANCE = '/correspondance';
export const URL_TIRAGES = '/tirages-minilab';
export const URL_TIRAGES_FORM = '/tirages-minilab-form';

export const LINK_FACEBOOK =
	'https://www.facebook.com/latelierargentiquenantes/';
export const LINK_INSTAGRAM = 'https://www.instagram.com/latelierargentique/';
export const LINK_NEWGRAIN = 'https://www.newgrain.app/labs/l-atelier-argentique';
export const LINK_NICOPETIT = 'https://capteur-argentique.fr/workshops/';
export const LINK_NICOPETITwashi =
	'https://capteur-argentique.fr/produit/workshop-argentique-film-washi/';
export const LINK_MINOLTOR = 'https://minoltor.fr/'

export const LINK_MAPS = 'https://goo.gl/maps/cEmHazv1bYmd2XkB7';
export const LINK_EMAIL = `mailto:${EMAIL}`;
export const LINK_PHONE = `tel:${PHONE_NUMBER}`;

// Content
export const TEXT = 'text';
export const HTML = 'html';
export const IMAGE = 'image';

export const BITMAP = 'bitmap';
export const VECTOR = 'vector';

// SVG
export const LOGO_ATELIER_ARGENTIQUE = 'logo-atelier-argentique.svg';
export const LOGO_FACEBOOK = 'logo-facebook.svg';
export const LOGO_INSTAGRAM = 'logo-instagram.svg';
export const LOGO_NEWGRAIN = 'logo-newgrain.svg';
export const ICON_TRIANGLE_TRAITS = 'icon-triangle-traits.svg';

export const TARIF_TIRAGES_UNIT = 0.45;
export const TARIF_TIRAGES_DEGRESSIVE_1 = 0.4;
export const TARIF_TIRAGES_DEGRESSIVE_2 = 0.35;
export const DEGRESSIVE_QTY_1 = 49;
export const DEGRESSIVE_QTY_2 = 50;

export const DROPBOX_CONTENT_URL = 'https://content.dropboxapi.com/2/';
export const DROPBOX_API_URL = 'https://api.dropbox.com/';
